export default {
  promote: {
    label: '推广产品资产',
    describe: '推广产品信息管理',
    table: {
      listEmpty: {
        describe: '您还没有推广产品，立即新增吧！',
      },
      operation: {
        rules: '产品名称不能为空',
        edittips: '编辑',
        refresh: '刷新',
        deletes: '删除',
        deletetips: '该产品已关联素材，不可删除。',
        delete: {
          label: '删除该推广产品',
          describe: '删除后将无法恢复，确定删除吗？',
        },
      },
      ios: {
        rules: '请输入 iOS 平台下的产品名称',
        package: '请输入 iOS 平台下的包名',
        description: '请输入 iOS 平台下的描述',
      },
      android: {
        rules: '请输入 Android 平台下的产品名称',
        package: '请输入 Android 平台下的包名',
        description: '请输入 Android 平台下的描述',
      },
      website: {
        description: '请输入描述',
        rules: '请输入产品名称',
      },
      error: '跳转 URL 格式错误',
      upload: {
        rules: '图标文件大小不得超过{fileSize}',
      },
      platforminfo: '平台',
      name: '产品名称',
      operations: '操作',
      updatetime: '更新时间',
    },
    rules: {
      placeholder: 'URL不能为空',
    },
    icon: {
      rules: '图标不能为空',
    },
    info: '关联的推广产品',
    filter: {
      placeholder: '搜索产品名称或包名',
      platform: '平台',
    },
    edit: {
      label: '编辑推广产品',
      package: '包名',
      url: 'URL',
      icon: '图标',
    },
    wxgame: {
      title: '微信小游戏',
      appid: '小游戏APPID',
      name: '小游戏名称',
      requiredTips: '请输入内容',
      icon: '小游戏图标',
    },
  },
}
